import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import RuleGroupForm from "./RuleGroupForm";
import { IRuleGroupElement } from "../../../model/evaluation/RuleGroupElement";
import RuleGroupPresentationModel from "../../../presenter/evaluation/model/RuleGroupPresentationModel";

export interface State {
  selectedBusinessRuleIds?: string[];
  setSelectedBusinessRuleIds?: any;
  setElements?: any;
  elements: IRuleGroupElement[];
}

export interface CreateRuleGroupFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: any;
}

class CreateRuleGroupForm extends React.Component<
  CreateRuleGroupFormProps,
  State
> {
  constructor(props: CreateRuleGroupFormProps) {
    super(props);
    this.state = {
      selectedBusinessRuleIds: [],
      elements: [],
      setSelectedBusinessRuleIds: selectedRules => {
        this.setState({ selectedBusinessRuleIds: selectedRules });
      },
      setElements: elements => {
        this.setState({ elements: elements });
      }
    };
  }
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newData;

      const { selectedBusinessRuleIds, elements } = this.state;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newData = RuleGroupPresentationModel(values);
          newData.ruleGroupElements = elements;
          newData.selectedElementsIds = selectedBusinessRuleIds;
        }
      });
      return newData;
    });
  }

  render() {
    const { translate, codebooks } = this.props;
    const { setSelectedBusinessRuleIds, setElements } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <RuleGroupForm
        codebooks={codebooks}
        translate={translate}
        getFieldDecorator={getFieldDecorator}
        setElements={setElements}
        setSelectedBusinessRuleIds={setSelectedBusinessRuleIds}
      />
    );
  }
}

export default CreateRuleGroupForm;
